import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import { Icon, Div, Flex, Button } from 'ui';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withRouter } from 'utils/withRouter';
import { Modal } from 'antd';
import OriginalSectionContainer from '../containers/original-section-container';
import TranslatedSectionContainer from '../containers/translated-section-container';

const StyledIcon = styled(Icon)`
  margin-right: 5px;
  color: black;
  vertical-align: sub;
  font-size: 30px;
`;

const StyledTitle = styled.span`
  font-size: 20px;
`;

const StyledModal = styled(Modal)`
  width: 50% !important;
`;

const StyledDiv = styled(Div)`
  width: 48%;
`;

const StyledButton = styled(Button)`
  text-transform: uppercase;
  ${p => p.marginRight && `margin-right: ${p.marginRight};`}
`;

const TranslationModal = ({
  visible,
  onCancel,
  intl,
  fetchTranslatorLanguages,
  locale,
  isLoading,
  detectLanguage,
  textToTranslate,
  setTranslatedValue,
}) => {
  const [translateFromLanguage, setTranslateFromLanguage] = useState();
  const [translatedTextValue, setTranslatedTextValue] = useState();
  const [originalTextValue, setOriginalTextValue] = useState();

  useEffect(() => {
    if (visible) {
      const userLanguage = locale || 'en';
      fetchTranslatorLanguages({ userLanguage });
      setOriginalTextValue(
        textToTranslate,
      );
      if (
        textToTranslate
      ) {
        detectLanguage({
          text: textToTranslate,
        });
      }
    } else {
      setTranslatedTextValue('');
    }
  }, [visible]);

  const addTranslationToOriginalText = () => {
    setTranslatedValue(translatedTextValue);
    onCancel();
  };

  const renderTitle = () =>
    <>
      <StyledIcon type='language' />
      <StyledTitle>{intl.formatMessage({ id: 'translation.TRANSLATE' })}</StyledTitle>
    </>;
  return (
    <StyledModal title={renderTitle()} open={visible} footer={null} onCancel={onCancel}>
      <Flex jcsb>
        <StyledDiv>
          <OriginalSectionContainer
            translateFromLanguage={translateFromLanguage}
            setTranslateFromLanguage={setTranslateFromLanguage}
            setOriginalTextValue={setOriginalTextValue}
            originalTextValue={originalTextValue}
            visible={visible}
            isDisabled={true}
          />
        </StyledDiv>
        <StyledDiv>
          <TranslatedSectionContainer
            translateFromLanguage={translateFromLanguage}
            setTranslatedTextValue={setTranslatedTextValue}
            translatedTextValue={translatedTextValue}
            originalTextValue={originalTextValue}
          />
        </StyledDiv>
      </Flex>
      <Flex jcfe marginTop={20}>
        <>
          <StyledButton
            marginRight='12px'
            type='secondary'
            light={true}
            onClick={onCancel}
          >
            {intl.formatMessage({ id: 'translation.CANCEL' })}
          </StyledButton>
          <StyledButton
            type='secondary'
            onClick={addTranslationToOriginalText}
            disabled={isLoading || !translatedTextValue}
          >
            {intl.formatMessage({ id: 'translation.ADD_TRANSLATION' })}
          </StyledButton>
        </>
      </Flex>
    </StyledModal>
  );
};
TranslationModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  intl: PropTypes.object,
  fetchTranslatorLanguages: PropTypes.func,
  locale: PropTypes.string,
  isLoading: PropTypes.bool,
  textToTranslate: PropTypes.string,
  detectLanguage: PropTypes.func,
  setTranslatedValue: PropTypes.func,
};

export default injectIntl(withRouter(TranslationModal));
